import * as Sentry from "@sentry/react";
import { getUserFromLocalStorage } from "@/utils/getUserFromLocalStorage";
import { ConciliationErrorFallback } from "./fallback";

type ScreenType = "evidence-register" | "nsu-register" | "redirect";

interface ConciliationErrorBoundaryProps {
  screen: ScreenType;
  children: React.ReactNode;
}

export function ConciliationErrorBoundary({
  screen,
  children,
}: ConciliationErrorBoundaryProps) {
  const getSentryContext = () => {
    const solicitationId = localStorage.getItem("@email:solicitationId");
    const user = getUserFromLocalStorage();

    return {
      solicitationId: solicitationId ?? "unknown",
      storeCode: user?.code ?? "unknown",
      conciliationStoreId: user?.conciliation_store_id ?? "unknown",
    };
  };

  return (
    <Sentry.ErrorBoundary
      beforeCapture={(scope) => {
        const context = getSentryContext();

        scope.setTag("module", "conciliation");
        scope.setTag("screen", screen);
        scope.setTag("error_type", "render_error");

        scope.setContext("conciliation", context);

        scope.addBreadcrumb({
          category: "conciliation",
          message: `Error on ${screen} screen`,
          level: "error",
          data: context,
        });
      }}
      fallback={({ error, resetError }) => (
        <ConciliationErrorFallback
          error={error}
          onRetry={resetError}
          screen={screen}
        />
      )}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}

export default ConciliationErrorBoundary;
